import { render, staticRenderFns } from "./UiPageLayout.vue?vue&type=template&id=26897f6f&scoped=true&"
var script = {}
import style0 from "./UiPageLayout.vue?vue&type=style&index=0&id=26897f6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26897f6f",
  null
  
)

export default component.exports